import { H3 } from "../ui/Heading";
import type { Capability } from "../data/capabilities";

export function CapabilityCard({ cap }: { cap: Capability }) {
  return (
    <div className="flex flex-col bg-bg-2 p-7 transition-colors duration-200 hover:bg-bg-3">
      <div className="flex justify-between items-start">
        <span className="font-mono text-xs tracking-widest text-accent">
          {cap.n}
        </span>
        <span className="font-mono text-[9px] uppercase tracking-[0.14em] text-td-3">
          {cap.tag}
        </span>
      </div>
      <H3 className="text-[22px] leading-tight mt-6 mb-3">{cap.title}</H3>
      <p className="flex-1 text-sm leading-relaxed text-td-2">{cap.body}</p>
    </div>
  );
}
